import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Brain, User, Volume2, Loader2, Square } from 'lucide-react';

export const MessageList = ({
  messages,
  loading,
  isSpeakingNow,
  voiceOutputEnabled,
  onSpeakMessage,
  onStopSpeaking,
  messagesEndRef,
  formatMessage,
  onTouchStart, onTouchMove, onTouchEnd,
}) => (
  <>
    <div
      className="flex-1 p-4 sm:p-6 overflow-y-auto space-y-4"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      <AnimatePresence>
        {messages.map((message, index) => {
          const isUser = message.role === 'user';
          const avatarCls = isUser ? 'bg-purple-500' : 'bg-gradient-to-br from-purple-500 to-indigo-500';
          const bubbleCls = isUser
            ? 'bg-purple-500 text-white'
            : 'bg-[var(--isp-glass-inner)] text-[var(--isp-heading)]';
          return (
            <motion.div
              key={message.id || `msg-${index}`}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}
            >
              <div className={`flex items-start gap-3 max-w-[85%] ${isUser ? 'flex-row-reverse' : ''}`}>
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${avatarCls}`}>
                  {isUser ? <User className="w-4 h-4 text-white" /> : <Brain className="w-4 h-4 text-white" />}
                </div>
                <div className={`p-4  ${bubbleCls}`}>
                  <div className="text-sm leading-relaxed">
                    {formatMessage(message.content)}
                  </div>
                  {message.role === 'assistant' && voiceOutputEnabled && (
                    <button
                      onClick={() => onSpeakMessage(message.content)}
                      className="mt-2 text-xs text-[var(--isp-muted)] hover:text-[var(--isp-body)] flex items-center gap-1"
                      title="Read aloud"
                    >
                      <Volume2 className="w-3 h-3" />
                      Read aloud
                    </button>
                  )}
                </div>
              </div>
            </motion.div>
          );
        })}
      </AnimatePresence>

      {loading && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="flex justify-start">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-500 to-indigo-500 flex items-center justify-center">
              <Brain className="w-4 h-4 text-white" />
            </div>
            <div className="bg-[var(--isp-glass-inner)] p-4 ">
              <div className="flex items-center gap-2 text-[var(--isp-body)]">
                <Loader2 className="w-4 h-4 animate-spin" />
                <span className="text-sm">Thinking...</span>
              </div>
            </div>
          </div>
        </motion.div>
      )}
      <div ref={messagesEndRef} />
    </div>

    {isSpeakingNow && (
      <div className="px-4 py-2 bg-purple-500/10 border-t border-purple-500/20 flex items-center gap-2">
        <div className="flex items-center gap-1">
          <span className="w-2 h-2 bg-purple-400 rounded-full animate-pulse" />
          <span className="w-2 h-2 bg-purple-400 rounded-full animate-pulse delay-75" />
          <span className="w-2 h-2 bg-purple-400 rounded-full animate-pulse delay-150" />
        </div>
        <span className="text-sm text-purple-300">Speaking...</span>
        <button
          onClick={onStopSpeaking}
          className="ml-auto text-xs text-purple-400 hover:text-purple-300 flex items-center gap-1"
        >
          <Square className="w-3 h-3" />
          Stop
        </button>
      </div>
    )}
  </>
);
